/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineScopeCloudAccount extends models.TagBaselineScope {
    constructor() {
        super();
        this.setDiscriminator("TagBaselineScopeCloudAccount");
    }

    getFixupPrototypeFunction() { return TagBaselineScopeCloudAccount.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineScopeCloudAccount>): TagBaselineScopeCloudAccount {
        let obj = Object.assign(new TagBaselineScopeCloudAccount(), model);
        TagBaselineScopeCloudAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineScopeCloudAccount>): TagBaselineScopeCloudAccount {
        if (!model) return null;
        return TagBaselineScopeCloudAccount.newInstance(<TagBaselineScopeCloudAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineScopeCloudAccount) {
        if (!obj) return;

        models.TagBaselineScopeCloudAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineScopeCloudAccount): boolean {
        if (models.TagBaselineScope.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineScopeCloudAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    cloud_account_ids: Array<string>;

}
